import type { JSONContent } from "@tiptap/core";

import { SUPPORTED_MARK_TYPES, SUPPORTED_NODE_TYPES } from "./constants";

const isNodeSupported = (node: JSONContent): boolean => {
  if (!node.type || !SUPPORTED_NODE_TYPES.has(node.type)) {
    return false;
  }
  if (node.marks?.some(mark => !SUPPORTED_MARK_TYPES.has(mark.type))) {
    return false;
  }
  return !node.content?.length || node.content.every(isNodeSupported);
};

interface CanRenderStaticallyParams {
  attachments?: unknown[];
  body?: JSONContent;
  unfurlUrls?: Record<string, unknown> | null;
}

// A message body can render statically only when it has no attachments, no
// link-unfurl previews, and every node/mark is a type we support. This scopes
// the static path to the common case (text + marks + mentions + entities) and
// falls back to the editor for everything else.
export const canRenderStatically = ({
  attachments,
  body,
  unfurlUrls,
}: CanRenderStaticallyParams): boolean => {
  if (!body?.content?.length) {
    return false;
  }
  if (attachments && attachments.length > 0) {
    return false;
  }
  if (unfurlUrls && Object.keys(unfurlUrls).length > 0) {
    return false;
  }
  return body.content.every(isNodeSupported);
};
